<template>
  <section class="lg:py-24 py-12">
    <div class="container mx-auto px-4 sm:px-6 lg:px-8">
      <div class="grid grid-cols-12">
        <div class="col-span-12">
          <div class="text-left md:text-center mb-12 md:mb-16">
            <h2
              class="text-2xl sm:text-3xl md:text-4xl font-heading font-semibold text-gray-900 mb-4 leading-tight"
            >
              The process
            </h2>
            <p class="text-base sm:text-lg text-gray-600">
              The process & timeline we use for every client to generate
              immediate returns and ensure long-term success.
            </p>
          </div>

          <div class="grid grid-cols-12 gap-8">
            <div class="col-span-12 md:col-span-4">
              <ProcessCard
                :icon="MagnifyingGlassIcon"
                title="TRACK & ANALYZE"
                timeline=""
                :items="[
                  'Tracking audit',
                  'Event driven design',
                  'Server-side Setup Tracking Setup',
                  'Ad Platform Tracking Setup ',
                  'Attribution Gap Assessment',
                  'Goal & KPI Definition',
                ]"
              />
            </div>

            <div class="col-span-12 md:col-span-4">
              <ProcessCard
                :icon="StarIcon"
                title="CREATE"
                timeline=""
                :items="[
                  'Revenue tracking dashboard',
                  'Ad Spend tracking dashboard',
                  'Customer acquisition cost (CAC) and lifetime value (LTV) metrics',
                  'Data Validation & QA Testing',
                  'Dashboard Development with essential KPIs',
                  'Weekly Progress Reports & Check-ins',
                ]"
              />
            </div>

            <div class="col-span-12 md:col-span-4">
              <ProcessCard
                :icon="ChevronDoubleUpIcon"
                title="ELEVATE"
                timeline=""
                :items="[
                  'Custom KPI & Goals',
                  'Ongoing Data Quality Monitoring & Anomaly Detection',
                  'Performance Insights',
                  'Custom Reporting & Deep Dives',
                  'Monthly/Quarterly Strategy Review & Data-Driven Consultation',
                ]"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import ProcessCard from "@/components/shared/ProcessCard.vue";
import {
  MagnifyingGlassIcon,
  StarIcon,
  ChevronDoubleUpIcon,
} from "@heroicons/vue/24/outline";
</script>
